module.exports = __webpack_public_path__ + "media/images/label_note-4de18872.png";